<template>
    <span v-if="status !== 'none'" class="status" :class="status" style="width: 132px">
        <template v-if="status === 'progress'"> {{ $t('audit.status.progress') }} {{ percentage }}% </template>
        <template v-else-if="status === 'completed'"> {{ $t('audit.status.completed') }} {{ percentage }}% </template>
        <template v-else-if="status === 'to_start'">
            {{ $t('audit.status.to_start') }}
        </template>
    </span>
    <span v-else class="status"> - </span>
</template>

<script>
export default {
    name: 'StatusTag',
    props: {
        percentage: {
            type: Number
        }
    },
    computed: {
        status() {
            if (!this.percentage) return 'none'
            if (this.percentage === 0) return 'none'
            if (this.percentage === 100) return 'completed'
            if (this.percentage > 0 && this.percentage < 100) return 'progress'
            return 'to_start'
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.status {
    font-size: 12px;
    padding: 4px 4px;
    border-radius: 3px;
    position: relative;
    top: -3px;
    font-family: $text-bold;
    display: inline-flex;
    align-items: baseline;
    justify-content: center;
    min-width: 110px;
    padding: 0 8px;

    &.completed {
        background-color: $color-success-100;
        color: $color-success-800;

        &::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: $color-success-500;
            margin-right: 4px;
        }
    }

    &.progress {
        background-color: $color-warning-100;
        color: $warning-dark;

        &::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: $warning-dark;
            margin-right: 4px;
        }
    }

    &.to_start {
        background-color: $color-neutral-500;
        color: white;
    }
}
</style>
